import React, { useEffect, useState } from 'react';
import { ChevronLeft } from 'lucide-react';
import { useGetCommonContentQuery } from "../../../hooks/useCommon"
import { useNavigate } from "react-router-dom"
import { useStore } from '@tanstack/react-store';
import { themeStore } from '../../../stores/theme';

const Privacy = () => {
    const { isDarkMode } = useStore(themeStore)
    const [commonContent, setCommonContent] = useState([])
    const { data: commonData, isSuccess: isCommonDataSuccess } = useGetCommonContentQuery(`?language=en`)
    const navigate = useNavigate()

    useEffect(() => {
        if (isCommonDataSuccess) {
            setCommonContent(commonData?.data?.data);
        }
    }, [commonData, isCommonDataSuccess])

    const handleBackClick = () => {
        navigate(-1)
    };

    return (
        <div className={`min-h-screen ${isDarkMode?"bg-gray-800": "bg-white"}`}>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* Header */}
                <div className="flex items-center mb-8">
                    <button
                        onClick={handleBackClick}
                        className={`${isDarkMode? "bg-gray-800": "bg-white" } mr-4 p-2 rounded-lg transition-colors border-2 border-blue-500`}>
                        <ChevronLeft className="w-6 h-6 text-blue-600" />
                    </button>
                    <h1 className={`${isDarkMode?"text-white": "text-gray-800"} text-3xl font-bold text-center flex-1`}>PRIVACY POLICY</h1>
                </div>
                <div className={`${isDarkMode?"bg-gray-800 border-gray-700": "bg-white border-gray-100"} rounded-3xl border-2 p-20 shadow-lg`}>
                    <div
                        className={`${isDarkMode?"text-white":"text-gray-700"} leading-relaxed`}
                        dangerouslySetInnerHTML={{ __html: commonContent?.privacy_policy }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Privacy;